module.exports = __webpack_public_path__ + "img/CG.bd3df08c.svg";